import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col, Form, Table, Button } from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import obj from "../utils/constants";
import apiPath from "../utils/apiPath";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";
import helpers from "../utils/helpers";
import AuthContext from "../context/AuthContext";
import { isEmpty, startCase, upperCase } from "lodash";
import ListHeaderNew from "../components/ListHeaderNew";
import Pagination from "../components/Pagination";
import DatePicker from "react-datepicker";

const BalanceLogs = () => {
  let { user } = useContext(AuthContext);

  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [pageCount, setPageCount] = useState(0);
  const [viewpage, setViewPage] = useState(0);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    fromPeriod: previousDate,
    toPeriod: currentDate,
    page: 1,
    limit: 100,
  });

  const getData = async (type = "search") => {
    if (filter.filterByDay != "") {
      if (filter.filterByDay == "today") {
        filter.fromPeriod = currentDate;
        filter.toPeriod = currentDate;
      }
      if (filter.filterByDay == "yesterday") {
        filter.fromPeriod = previousDate;
        filter.toPeriod = currentDate;
      }
    }
    const { status, data: response_users } = await apiGet(
      apiPath.transactionLogs,
      filter
    );
    if (status === 200) {
      if (response_users.success) {
        setData(response_users.results);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (type) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: 1,
      };
    });
    getData(type);
  };
  const handlePageClick = (event) => {
    setFilter((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
    setViewPage(event.selected);
  };

  return (
    <div>
      <section className="main-inner-outer pt-3">
        <div className="db-sec">
          <h2 className="common-heading">Balance Log</h2>
        </div>
        <div className="inner-wrapper">
          <div className="common-container">
            <Form className="mb-2">
              <div className="bet_status mb-0">
                <Row>
                  <Col xxl={12} lg={12} md={12}>
                    <Row>
                      <Col lg={7} sm={8} className="mb-lg-0 mb-3">
                        <div
                          className="d-flex"
                          style={{ alignItems: "baseline" }}
                        >
                          <div
                            className="bet-sec"
                            style={{ marginRight: "10px" }}
                          >
                            <Form.Label
                              style={{ alignSelf: "baseline" }}
                              className="mt-2 me-2"
                            >
                              eventId:
                            </Form.Label>
                            <Form.Control
                              style={{ width: "150px" }}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  eventId: e.target.value,
                                })
                              }
                              placeholder="enter eventId....."
                              className="input-new-textarea"
                              value={filter.eventId}
                              aria-label="Default select example"
                            />
                          </div>
                          <div
                            className="bet-sec"
                            style={{ marginRight: "10px" }}
                          >
                            <Form.Label
                              style={{ alignSelf: "baseline" }}
                              className="mt-2 me-2"
                            >
                              marketId:
                            </Form.Label>
                            <Form.Control
                              style={{ width: "150px" }}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  marketId: e.target.value,
                                })
                              }
                              placeholder="enter marketId....."
                              className="input-new-textarea"
                              value={filter.marketId}
                              aria-label="Default select example"
                            />
                          </div>
                          <div
                            className="bet-sec"
                            style={{ marginRight: "10px" }}
                          >
                            <Form.Label
                              style={{ alignSelf: "baseline" }}
                              className="mt-1 me-2"
                            >
                              *userId:
                            </Form.Label>
                            <Form.Control
                              style={{ height: "50px", width: "200px" }}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  userId: e.target.value,
                                })
                              }
                              as="textarea"
                              type="textarea"
                              placeholder="enter userId....."
                              className="input-new-textarea"
                              cols={30}
                              rows={5}
                              value={filter.userId}
                              aria-label="Default select example"
                            />
                          </div>
                          <div
                            className="bet-sec bet-period"
                            style={{ marginRight: "10px" }}
                          >
                            <Form.Label className="mb-0">From</Form.Label>
                            <Form.Group className="form-group">
                              <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.fromPeriod
                                    ? new Date(filter.fromPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    fromPeriod: date
                                      .toISOString()
                                      .split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                maxDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                              <Form.Control
                                style={{ marginLeft: "2px", width: "47px" }}
                                className="small_form_control"
                                type="text"
                                placeholder="00:00"
                                disabled
                              />
                            </Form.Group>
                          </div>
                          <div className="bet-sec bet-period">
                            <Form.Label className="mb-0">To</Form.Label>
                            <Form.Group className="form-group">
                              <DatePicker
                                className="small_form_control"
                                selected={
                                  filter.toPeriod
                                    ? new Date(filter.toPeriod)
                                    : null
                                }
                                onChange={(date) =>
                                  setFilter({
                                    ...filter,
                                    toPeriod: date.toISOString().split("T")[0],
                                    filterByDay: "",
                                  })
                                }
                                dateFormat="yyyy-MM-dd"
                                minDate={
                                  filter?.fromPeriod
                                    ? new Date(filter?.fromPeriod)
                                        .toISOString()
                                        .split("T")[0]
                                    : new Date()
                                }
                                maxDate={new Date().toISOString().split("T")[0]}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                placeholderText="Select a date"
                                onFocus={(e) => e.target.blur()}
                              />
                              <Form.Control
                                style={{ marginLeft: "2px", width: "47px" }}
                                className="small_form_control"
                                type="text"
                                placeholder="23:59"
                                disabled
                              />
                            </Form.Group>
                          </div>
                          <Button
                            style={{
                              marginLeft: "10px",
                              paddingLeft: "25px",
                              paddingRight: "25px",
                            }}
                            className="theme_light_btn theme_dark_btn"
                            onClick={() => getData()}
                          >
                            Submit
                          </Button>{" "}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Form>

            {/* <div className="account-table batting-table">
              <div className="responsive">
                <Table>
                  <thead>
                    <tr>
                      <th scope="col">UserId</th>
                      <th scope="col">Site</th>
                      <th scope="col">Event Id</th>
                      <th scope="col">EventName </th>
                      <th scope="col">Market Id</th>
                      <th scope="col">Market Name</th>
                      <th scope="col">Category</th>
                      <th scope="col">beforeBalance</th>{" "}
                      <th scope="col">afterBalance</th>
                      <th scope="col">profitLoss</th>
                      <th scope="col">remark</th>
                      <th scope="col">createDate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={12}>No Data</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              {data?.data?.length > 0 && (
                <Pagination
                  handlePageClick={handlePageClick}
                  pageCount={pageCount}
                  viewpage={viewpage}
                />
              )}
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BalanceLogs;
